export default {
  en: {
    'on_day': 'on day: {day}',
    'current_day': 'current day: {day}',
    'current_team_slots': ' current team, slots {current}/{slots}',
    'scouting_youth_players_scout_assigned': '{assigned}/{total} scouts',
    'youth_players_recruited': '{recruited}/{total} recruited',
    'negotiators_assign': 'negotiators assign: {usedSlots}/{totalSlots}',
    'matches_short': 'm',
    'wins_short': 'w',
    'draws_short': 'd',
    'loses_short': 'l',
    'points_short': 'p',
    'season_x': 'season: {season}',
    'processing': 'processing',
    'generate': 'generate',
    'restart': 'restart',
    'evaluating': 'evaluating',
    'stop': 'stop',
    'buy': 'buy',
    'start_negotiations': 'start negotiations',
    'do_you_want_to_start_negotiations_for_player': 'Do you want to start negotiations for <strong>{player}</strong>?',
    'actions': 'actions',
    'buy_for_x_price': 'Buy for {price}!',
    'no_entries': 'No entries.',
    'confirm': 'confirm',
    'money_per_month': '{x}/m',
    'month_short': 'm',
    'skip_one_month': 'skip one month',
    'manage': 'manage',
    'sure?': 'sure?',
    'navigation': 'navigation',
    '': '',
  }
};
